import React from 'react';
import InfiniteScroll from "react-infinite-scroll-component";


const LazyRodeoEventLeaderBoard = React.lazy(() =>
    import('./leaderboard')
);

const LeaderBoard = (props: Record<string, any>) => (
    <React.Suspense fallback={<h1>Loading...</h1>}>
        <LazyRodeoEventLeaderBoard {...props} />
    </React.Suspense>
);

export default LeaderBoard